export default __webpack_public_path__ + "static/media/acessibility-image.87af978a.svg";